export default function App() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-600 via-primary-700 to-primary-900 rounded-3xl overflow-hidden relative">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 right-10 w-64 h-64 rounded-full bg-white/20 blur-3xl"></div>
            <div className="absolute bottom-10 left-10 w-48 h-48 rounded-full bg-accent-500/30 blur-3xl"></div>
          </div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8 lg:gap-12 px-8 md:px-12 py-12 md:py-16">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-4 py-1.5 rounded-full bg-white/20 text-white text-xs font-medium mb-5 backdrop-blur-sm">
                随时随地 · 想看就看
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white mb-4">
                丫丫影院移动端
              </h2>
              <p className="text-white/80 text-sm md:text-base leading-relaxed mb-8 max-w-lg mx-auto lg:mx-0">
                专为移动观影优化的独立应用，支持离线缓存、画中画播放、夜间模式等功能。地铁上、旅途中、睡前时光，随时随地畅享高清影视。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <div className="flex items-center gap-3 px-6 py-3 rounded-xl bg-white/15 backdrop-blur-sm text-white cursor-pointer hover:bg-white/25 transition-colors">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-apple-line text-xl"></i>
                  </div>
                  <div className="text-left">
                    <div className="text-xs opacity-70">iOS 版本</div>
                    <div className="text-sm font-medium whitespace-nowrap">App Store 下载</div>
                  </div>
                </div>

                <div className="flex items-center gap-3 px-6 py-3 rounded-xl bg-white/15 backdrop-blur-sm text-white cursor-pointer hover:bg-white/25 transition-colors">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-android-line text-xl"></i>
                  </div>
                  <div className="text-left">
                    <div className="text-xs opacity-70">Android 版本</div>
                    <div className="text-sm font-medium whitespace-nowrap">官方APK下载</div>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6">
                {[
                  { icon: 'ri-download-cloud-2-line', text: '离线缓存' },
                  { icon: 'ri-moon-clear-line', text: '夜间模式' },
                  { icon: 'ri-aspect-ratio-line', text: '画中画' },
                  { icon: 'ri-smartphone-line', text: '全端适配' },
                ].map((item) => (
                  <div key={item.text} className="flex items-center gap-2 text-white/70 text-xs">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={item.icon}></i>
                    </div>
                    <span className="whitespace-nowrap">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative">
                <div className="w-56 md:w-64 h-auto rounded-2xl overflow-hidden shadow-2xl border-4 border-white/20">
                  <img
                    src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20movie%20streaming%20app%20interface%20with%20film%20posters%20grid%20and%20dark%20theme%20UI%2C%20modern%20minimal%20design%2C%20clean%20layout%2C%20mobile%20app%20screen%20on%20device&width=360&height=640&seq=app-mobile-2026&orientation=portrait"
                    alt="丫丫影院移动端界面"
                    className="w-full h-auto object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}